import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import Testimonio from "../atoms/Testimonio";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import "./Testimonios.css";

export const Testimonios = () => {
  const testimonios = [
    [
      "Inés L., 54 años",
      '"Mamá vive sola y yo estaba preocupada de que se cayera y nadie se enterara. Con el botón de aydua de Ellie Care y su centro de monitoreo 24hs, con mis hermanos nos sentimos mucho más tranquis. ¡Y mamá también!"',
    ],
    [
      "Jorge Z., 76 años",
      '"Me gusta mucho el Ellie Watch. Lo uso como un smartwatch tradicional, veo mi actividad física, mis signos vitales, pero además tiene el Botón de Ayuda conectado al Ellie Center y a mi Red de Ayuda"',
    ],
    [
      "Marta M., 91 años",
      '"Me siento más tranquila con Ellie Care. Me lo regalaron mis hijos y ya les pedí para mi cumpleaños el Ellie Watch."',
    ],
    [
      "Carlos GB., 61 años",
      '"Vivo solo y la verdad que me preocupaba que me pase algo y nadie se entere. Me siento mucho más tranquilo con Ellie Care, y mis sobrinos también."',
    ],
  ];

  return (
    <div id="testimonios">
      <div className="testimonios-container">
        <div className="testimonios-slider">
          <Swiper
            loop={true}
            autoplay={{ delay: 50000, disableOnInteraction: false }}
            slidesPerView="auto"
            spaceBetween={0}
            speed={1000}
            modules={[Autoplay, Pagination]}
            pagination={{ clickable: true }}
          >
            {testimonios.map((testimonio, index) => (
              <SwiperSlide key={index}>
                <Testimonio name={testimonio[0]} text={testimonio[1]} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Testimonios;
